module.exports = __webpack_public_path__ + "static/img/icon_lhdj.96e5b746.png";